import { withStyles, WithStyles } from "@mui/styles";
import buttonStyle from "assets/jss/mui-extras/buttonStyle";
import classNames from "classnames";
import * as React from "react";

export type MuiRegularButtonColors = "default" | "primary" | "secondary" | "info" | "success" | "pressed" | "warning" | "error" | "white" | "transparent" | "inherit";

interface IProps {
    title?: string,
    color?: MuiRegularButtonColors,
    simple?: boolean,
    round?: boolean,
    disabled?: boolean,
    block?: boolean,
    link?: boolean,
    justIcon?: boolean,
    noPadding?: boolean,
    noMargin?: boolean,
    width?: "fit" | "small" | "large",
    className?: string,
    // use this to pass the classes props from Material-UI
    muiClasses?: object;
}

export type MuiRegularButtonProps = IProps;

type Props = MuiRegularButtonProps & WithStyles<typeof buttonStyle>;

const MuiFakeButton: React.FC<Props> = (props) => {
    const {
        classes,
        color,
        round,
        children,
        disabled,
        simple,
        block,
        link,
        justIcon,
        className,
        noPadding,
        noMargin,
        width,
        ...rest
    } = props;

    const btnClasses = classNames({
        [classes.fakeButton]: true,
        [classes.button]: true,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [classes.noPadding]: noPadding,
        [classes.noMargin]: noMargin,
        [classes.widthFit]: width == "fit",
        [classes.widthLarge]: width == "large",
        [className]: className
    });
    return (
        <span
            {...rest}
            className={btnClasses}
        >
            {children}
        </span>
    );
};

MuiFakeButton.defaultProps = {
    round: false,
    disabled: false,
    simple: false,
    block: false,
    link: false,
    justIcon: false,
    noPadding: false,
    noMargin: false
};

export default withStyles(buttonStyle)(MuiFakeButton);
